import React from 'react';
import {Platform} from 'react-native';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useRankPerformanceSection} from './RankPerformanceSection.hook';
import {RankPerformanceSectionProps} from './RankPerformanceSection.types';

export const RankPerformanceSection = ({
  aboveRank = 0,
  atRank = 0,
  belowRank = 0,
  onShowReport = () => {},
  onShowInfoPopover = () => {},
}: RankPerformanceSectionProps) => {
  const containerStyle = Platform.OS === 'web' ? {marginBottom: 8} : undefined;
  const {onInfoPress, onItemPress, listItems, ts} = useRankPerformanceSection({
    aboveRank,
    atRank,
    belowRank,
    onShowReport,
    onShowInfoPopover,
  });

  return (
    <MetricSection
      analyticsTitle="Rank Performance"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Rank Performance Section Information',
      )}
      testID={MetricsSection.metricSectionRankPerformance}
      title={ts('heading', 'Rank Performance')}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
      containerStyle={containerStyle}
    />
  );
};

export default RankPerformanceSection;
